<script lang="ts" setup>
import LinkButton from "@/components/buttons/LinkButton.vue";
import { useI18n } from "vue-i18n";
import { DispatcherPermissionValue } from "@/api/dto/dispatcher.dto";
import PermissionTooltip from "@/components/tooltips/PermissionTooltip.vue";

const { t } = useI18n();
</script>

<template>
  <permission-tooltip :permission="DispatcherPermissionValue.EditOrCreateUser">
    <template #activator="{ disabled }">
      <link-button id="create-user-btn" :disabled="disabled" :to="{ name: 'user-create' }" color="success">
        {{ t("general.create-new") }}
      </link-button>
    </template>

    {{ t("permission.create-user") }}
  </permission-tooltip>
</template>
